/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_StoryInputs */

const en_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Story`)
};

const es_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar Historia`)
};

const fr_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l'Histoire`)
};

const de_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschichte bearbeiten`)
};

const ja_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストーリーを編集`)
};

const zh_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑故事`)
};

const ar_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعديل القصة`)
};

const id_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Cerita`)
};

const it_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica la Storia`)
};

const ru_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать Историю`)
};

const pt_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar História`)
};

const ko_edit_story = /** @type {(inputs: Edit_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토리 편집`)
};

/**
* | output |
* | --- |
* | "Edit Story" |
*
* @param {Edit_StoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const edit_story = /** @type {((inputs?: Edit_StoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_StoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_story(inputs)
	if (locale === "es") return es_edit_story(inputs)
	if (locale === "fr") return fr_edit_story(inputs)
	if (locale === "de") return de_edit_story(inputs)
	if (locale === "ja") return ja_edit_story(inputs)
	if (locale === "zh") return zh_edit_story(inputs)
	if (locale === "ar") return ar_edit_story(inputs)
	if (locale === "id") return id_edit_story(inputs)
	if (locale === "it") return it_edit_story(inputs)
	if (locale === "ru") return ru_edit_story(inputs)
	if (locale === "pt") return pt_edit_story(inputs)
	return ko_edit_story(inputs)
});